var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.7539 2.48047L12.5117 0.722656V5.99609H7.23828L9.66406 3.57031C8.77344 2.67969 7.71875 2.23438 6.5 2.23438C5.25781 2.23438 4.19141 2.67969 3.30078 3.57031C2.43359 4.4375 2 5.49219 2 6.73438C2 7.97656 2.43359 9.04297 3.30078 9.93359C4.19141 10.8008 5.25781 11.2344 6.5 11.2344C7.36719 11.2344 8.21094 10.9414 9.03125 10.3555C9.875 9.76953 10.4492 9.06641 10.7539 8.24609H12.3008C11.9727 9.55859 11.2695 10.6367 10.1914 11.4805C9.11328 12.3242 7.88281 12.7461 6.5 12.7461C4.85938 12.7461 3.45312 12.1602 2.28125 10.9883C1.10938 9.81641 0.523438 8.39844 0.523438 6.73438C0.523438 5.07031 1.10938 3.65234 2.28125 2.48047C3.45312 1.30859 4.85938 0.722656 6.5 0.722656C7.20312 0.722656 7.96484 0.898438 8.78516 1.25C9.62891 1.57812 10.2852 1.98828 10.7539 2.48047Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.ac438e48289e499897d14b31444e0072.svg";
export { ForwardRef as ReactComponent };